
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

interface MobileNavigationProps {
  isOpen: boolean;
  scrollToGallery: (e: React.MouseEvent) => void;
}

export const MobileNavigation = ({ isOpen, scrollToGallery }: MobileNavigationProps) => {
  if (!isOpen) return null;

  return (
    <div className="md:hidden">
      <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
        <Link to="/" className="block px-3 py-2 text-base font-inter text-secondary-dark hover:text-primary">
          Home
        </Link>
        <Link to="/secondary-glazing" className="block px-3 py-2 text-base font-inter text-secondary-dark hover:text-primary">
          Services
        </Link>
        <Link to="/fixed-units-glazing" className="block px-3 py-2 text-base font-inter text-secondary-dark hover:text-primary">
          Window Types
        </Link>
        <Link to="/secondary-glazing-benefits" className="block px-3 py-2 text-base font-inter text-secondary-dark hover:text-primary">
          Benefits
        </Link>
        <a href="#gallery" onClick={scrollToGallery} className="block px-3 py-2 text-base font-inter text-secondary-dark hover:text-primary">
          Gallery (This Page)
        </a>
        <Link to="/secondary-glazing-images" className="block px-3 py-2 text-base font-inter text-secondary-dark hover:text-primary">
          Full Gallery
        </Link>
        <Link to="/blog-secondary-glazing" className="block px-3 py-2 text-base font-inter text-secondary-dark hover:text-primary">
          Blog
        </Link>
        <Link to="/free-resources" className="block px-3 py-2 text-base font-inter text-secondary-dark hover:text-primary">
          Free Guides
        </Link>
        <Link to="/contact" className="block px-3 py-2 text-base font-inter text-secondary-dark hover:text-primary">
          Contact
        </Link>
        <Link to="/get-quote">
          <Button className="w-full mt-2 bg-primary hover:bg-primary-light text-white">Get Quote</Button>
        </Link>
      </div>
    </div>
  );
};
